import Form from "antd/lib/form/Form";
import React, { useContext, useEffect, useState } from "react";
import Wizard from "./Wizard";
import QalortButton from "../../Button";
import BaseInput from "../../BaseInput";
import RadioButton from "../../radio/RadioButton";
import {
  CreateNewCohort,
  DeleteCohort,
  UpdateCohort,
} from "../../../services/cohortService";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../../../context";
import dayjs from "dayjs";
import { DeleteButton } from "./CohortDetails";
import { isDraft } from "@reduxjs/toolkit";

function OtherDetails({
  isOpen,
  isDone,
  handleBack,
  hopToLevel,
  // setSuccessModal,
  setNewCohort,
}) {
  const { formFields, updateContext } = useContext(AppContext);
  const [video, setVideo] = useState("No");
  const [faqs, setFaqs] = useState(
    formFields?.faqs?.map((f) => ({
      question: f.question,
      answer: f.answer,
    })) || [{ question: "", answer: "" }]
  );
  const [loading, setLoading] = useState(false);
  const [step3Form] = Form.useForm();
  const navigate = useNavigate();
  const params = new URLSearchParams(window.location.search);
  const from = params.get("from");

  const handleAddFaq = () => {
    setFaqs((prevFaqs) => [...prevFaqs, { question: "", answer: "" }]);
  };

  const onSubmitCohort = async (e) => {
    const refinedStartDate =
      typeof formFields.start_date === "string"
        ? formFields.start_date.split("T")[0]
        : dayjs(formFields.start_date).format("YYYY-MM-DD");
    const formData = {
      ...formFields,
      start_date: refinedStartDate,
      end_date: !formFields.end_date
        ? refinedStartDate
        : formFields.end_date && typeof formFields.end_date === "string"
        ? formFields.end_date.split("T")[0]
        : dayjs(formFields.end_date).format("YYYY-MM-DD"),
    };

    const payload = {
      banner: formData.banner,
      title: formData.title,
      description: formData.description,
      end_date:
        formData.end_date?.split("T")[0] || formData.start_date?.split("T")[0],
      start_date: formData.start_date,
      schedules: formData.schedules,
      frequency: formData.frequency || "once",
      capacity: Number(formData.capacity),
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      status: "active",
      currency: formData.currency || "USD",
      faqs,
      price: formData.price || 0,
      auto_record: false,
      intro_video: formData.intro_video,
      long_description: formData.long_description,
      category_id: formData.category_id,
      capacity: Number(formData.mentees || formData.capacity),
      topics: formData?.topics?.map((t) => {
        return {
          title: t,
          topic: t,
        };
      }),
      audiences: formData?.audiences?.map((t) => {
        return {
          audience: t,
        };
      }),
      requirements: formData?.requirements?.map((t) => {
        return {
          content: t,
        };
      }),
    };

    if (dayjs(payload.end_date).isBefore(dayjs(payload.start_date))) {
      payload.end_date = payload.start_date;
    }
    console.log("formData", formData);
    console.log("payload", payload);

    // if (!payload.intro_video) {
    //   delete payload.intro_video;
    // }

    // if (!payload.price) {
    //   delete payload.price;
    //   delete payload.currency;
    // }

    setLoading(true);
    try {
      if (formFields.id && from !== "draft") {
        await UpdateCohort({ ...payload, status: "active" }, formFields.id);
        notification.success({
          message: "Cohort updated successfully",
        });
        navigate(`/ct/${formFields?.slug}`);
      } else {
        const res = await CreateNewCohort(payload);
        setNewCohort(res.data.data);
        if (from === "draft" && formFields.id) {
          DeleteCohort(formFields.id, true);
        }
        // setSuccessModal(true);
      }
      updateContext({});
    } catch (err) {
      notification.error({
        message:
          err.response?.data?.message || "An error occured. Please try again",
      });
    } finally {
      setLoading(false);
    }
  };

  const removeFAQ = (index) => {
    const faqs_ = [...faqs];
    faqs_.splice(index, 1);
    setFaqs(faqs_);
    updateContext({
      ...formFields,
      faqs: faqs_,
    });
  };

  useEffect(() => {
    step3Form.setFieldsValue({
      ...formFields,
    });

    if (formFields.faqs) {
      formFields.faqs.map((item, index) => {
        step3Form.setFieldValue(`answer.${index}`, item.answer);
        step3Form.setFieldValue(`question.${index}`, item.question);
      });
    }

    if (formFields.intro_video) {
      setVideo("Yes");
    }
  }, []);

  return (
    <>
      <Form onFinish={onSubmitCohort} form={step3Form}>
        <Wizard
          {...{ isOpen }}
          {...{ isDone }}
          step="3"
          details="Other Details"
          onClickHeader={() => {
            !step3Form.getFieldsValue().length && hopToLevel(3);
          }}
        >
          <div className="px-5 md:px-[62px]">
            <div className="py-[7px] px-3 w-full bg-light-tint mb-6">
              <p className="p-xs mb-0 font-medium text-dark">Other Details</p>
            </div>
            <div className="flex flex-col gap-4">
              {faqs.map((_, index) => (
                <div key={index} className="flex flex-col gap-2">
                  <BaseInput
                    label={`FAQ Question ${index + 1}`}
                    placeholder="E.g., Will there be a certificate after completing this class?"
                    name={`question.${index}`}
                    defaultValue={faqs[index].question}
                    onChange={(e) => {
                      setFaqs((prevFaqs) => {
                        const updatedFaqs = [...prevFaqs];
                        updatedFaqs[index] = {
                          ...updatedFaqs[index],
                          question: e.target.value,
                        };
                        return updatedFaqs;
                      });
                    }}
                    className="relative overflow-hidden"
                    suffixClassName="top-0 bottom-0 !right-0"
                  >
                    {index > 0 && (
                      <DeleteButton onClick={() => removeFAQ(index)} />
                    )}
                  </BaseInput>
                  <BaseInput
                    label={`FAQ Answer ${index + 1}`}
                    placeholder="Enter the answer here"
                    name={`answer.${index}`}
                    defaultValue={faqs[index].answer}
                    onChange={(e) => {
                      setFaqs((prevFaqs) => {
                        const updatedFaqs = [...prevFaqs];
                        updatedFaqs[index] = {
                          ...updatedFaqs[index],
                          answer: e.target.value,
                        };
                        return updatedFaqs;
                      });
                    }}
                  />
                </div>
              ))}
              <p
                className="p-xs font-medium text-disabled mt-2 mb-0 cursor-pointer"
                onClick={handleAddFaq}
              >
                + Add another question
              </p>
              <BaseInput
                label="Cohort co-host"
                placeholder="Enter Cohort co-host"
                defaultValue={formFields.cohost}
                onChange={(e) =>
                  updateContext({
                    ...formFields,
                    cohost: e.target.value,
                  })
                }
                name="co-host"
              />
              <div>
                <span className="p-xs font-medium text-main">
                  Have an explainer video?
                </span>
                <div className="flex gap-4">
                  <RadioButton
                    title="Yes"
                    className="fit"
                    value="Yes"
                    isChecked={video === "Yes"}
                    onChange={(e) => setVideo(e)}
                  />
                  <RadioButton
                    title="No"
                    className="fit"
                    value="No"
                    isChecked={video === "No"}
                    onChange={(e) => setVideo(e)}
                  />
                </div>
              </div>

              {video === "Yes" && (
                <BaseInput
                  placeholder="Paste the Youtube video link here"
                  defaultValue={formFields.intro_video}
                  name="intro_video"
                  onChange={(e) =>
                    updateContext({
                      ...formFields,
                      intro_video: e.target.value,
                    })
                  }
                />
              )}
            </div>
          </div>

          <div className="border-t border-grey-2 py-3.5 mt-9">
            <div className="flex gap-2.5 justify-end px-5 md:px-[62px]">
              <button
                className="border border-pri bg-pri-tint-3 pri py-2 px-9 rounded-md"
                onClick={handleBack}
                type="button"
              >
                Back
              </button>
              <QalortButton
                type="primary"
                className="py-3 px-9"
                loading={loading}
                htmlType="submit"
              >
                {formFields.id && !isDraft ? "Update" : "Create"} Cohort
              </QalortButton>
            </div>
          </div>
        </Wizard>
      </Form>
    </>
  );
}

export default OtherDetails;
